import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { get } from "lodash";
import moment from "moment";
import { withTranslation, useTranslation } from "react-i18next";
import { isEmpty, isUndefined } from "lodash";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import Booking from "../../model/booking";
import { BetTypeLi, RadioDiv } from "./AdditionalInformationStyle";
import DateTimePickerComponent from "./components/DateTimePickerComponent";
import BookingService from "../../backend/BookingService";
import FloatInput from "./FloatInput";
import ConfirmationFulfillmentModal from "../../components/modal/ConfirmationFulfillmentModal";
import ReservationService from "../../backend/ReservationService";

const AdditionalInformation = () => {
  const initialFormState = {
    bedType: "",
    flightArrivalDate: null,
    flightArrivalTime: null,
    arrivalDate: null,
    arrivalTime: null,
    arrivalFlight: null,
    specialRequest: "",
    licensePlateNumber: "",
  };
  const {
    propertyUid,
    bookingNumber,
    language,
    data: {
      guestService,
      configuration,
      presets,
      accessToken,
      booking,
      guests,
    },
    components: { PreCheckInHeader, PreCheckInContainer },
    func: {
      setLoading,
      setKeepLoading,
      useFormInput,
      updateErrorPage,
      setAccessTokenData,
      updateErrorModal,
      updateGuests,
    },
  } = usePreCheckInContext();
  const [formValues, handleFormChange] = useFormInput(initialFormState);
  const [currentGuest, setCurrentGuest] = useState();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const [booked, setBooked] = useState(false);
  const [retries, setRetries] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [validateForm, setValidateForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const bookingUploadData = () => {
    const allGuests = [...guests.allGuests()];
    let bookingCheckIn = get(booking, "check_in").split("T")[0];
    let bookingCheckOut = get(booking, "check_out").split("T")[0];
    const checkIn = moment
      .utc(bookingCheckIn + " " + configuration.checkInTimeText)
      .format("YYYY-MM-DD[T]HH:mm:ss");
    const checkOut = moment
      .utc(bookingCheckOut + " " + configuration.checkOutTimeText)
      .format("YYYY-MM-DD[T]HH:mm:ss");
    const bookingData = booking;
    const card = Booking.getCard(bookingNumber);
    const flightArrivalDate =
      (formValues.flightArrivalDate &&
        moment(formValues.flightArrivalDate).format("YYYY-MM-DD[T]HH:mm:ss")) ||
      "";
    const arrivalTime =
      (formValues.arrivalDate &&
        moment(formValues.arrivalDate).format("YYYY-MM-DD[T]HH:mm:ss")) ||
      "";

    const arrivalFlight =
      !isEmpty(formValues.arrivalFlight) &&
      !isUndefined(formValues.arrivalFlight)
        ? formValues.arrivalFlight
        : null;

    let key = "booking";

    let formData = {};
    formData["platform"] = "facebook";
    formData["device_type"] = "Web";
    formData[`${key}[profile_id]`] = bookingData.profile_id;
    formData[`${key}[email_id]`] = bookingData.email_id;
    formData[`${key}[room_code]`] = bookingData.room_code;
    formData[`${key}[room_description]`] = bookingData.room_description;
    formData[`${key}[resv_id]`] = (bookingData && bookingData.resv_id) || "";
    formData[`${key}[number_of_rooms]`] = bookingData.number_of_rooms || 0;
    formData[`${key}[total_guests]`] = bookingData.total_guests || 0;
    formData[`${key}[total_keys]`] = bookingData.total_keys || 0;
    formData[`${key}[address][address_id]`] =
      (bookingData.address && bookingData.address.address_id) || "";
    formData[`${key}[address][address_type]`] =
      (bookingData.address && bookingData.address.address_type) || "";
    formData[`${key}[address][city_name]`] =
      (bookingData.address && bookingData.address.city_name) || "";
    formData[`${key}[address][street]`] =
      (bookingData.address && bookingData.address.street) || "";
    formData[`${key}[phone][phone_id]`] =
      (bookingData.phone && bookingData.phone.phone_id) || "";
    formData[`${key}[phone][phone_type]`] =
      (bookingData.phone && bookingData.phone.phone_type) || "";
    formData[`${key}[phone][phone_role]`] =
      (bookingData.phone && bookingData.phone.phone_role) || "";
    formData[`${key}[privacy_option][promotions]`] =
      (bookingData.privacy_option && bookingData.privacy_option.promotions) ||
      "";
    formData[`${key}[room_rate]`] = bookingData.room_rate || "";
    formData[`${key}[advance_deposit]`] = bookingData.advance_deposit || "";
    formData[`${key}[passport][document_number]`] = "";
    let numberAdults = 0;
    let numberChildren = 0;

    if (allGuests) {
      for (let k in allGuests) {
        if (allGuests[k].adult || allGuests[k].adults) {
          numberAdults = allGuests[k].adult || allGuests[k].adults;
        }
        if (allGuests[k].child || allGuests[k].children) {
          numberChildren = allGuests[k].child || allGuests[k].children;
        }
      }
    }
    const currentGuestData = currentGuest || allGuests[0];
    formData[`${key}[number_adults]`] = numberAdults || "0";
    formData[`${key}[number_children]`] = numberChildren || "0";
    formData[`${key}[check_in]`] = checkIn;
    formData[`${key}[check_out]`] = checkOut;
    formData[`${key}[stripe_vs_id]`] = currentGuestData.clientSecret;
    formData[`${key}[save_verification_to_profile]`] =
      currentGuestData.saveVerificationToProfile;
    formData[`${key}[title]`] = currentGuestData.title;
    formData[`${key}[first_name]`] = currentGuestData.firstName;
    formData[`${key}[last_name]`] = currentGuestData.lastName;
    formData[`${key}[email]`] = currentGuestData.email;
    formData[`${key}[guest_id]`] =
      currentGuestData.guestId || currentGuestData.guest_id;
    formData[`${key}[guest_status]`] =
      currentGuestData.guestStatus || currentGuestData.guest_status;
    formData[`${key}[data_completed]`] = currentGuestData.completed && "true";
    if (card && card.transactionId) {
      formData[`${key}[transaction_id]`] = card.transactionId;
    }
    if (guestService.enablePassport) {
      formData[`${key}[address][country_of_residence_code]`] =
        currentGuestData.countryCode;
      formData[`${key}[address][country_of_residence]`] =
        currentGuestData.country;

      formData[`${key}[address][address_one]`] =
        (currentGuestData.address && currentGuestData.address.address_one) ||
        "";
      formData[`${key}[address][address_two]`] =
        (currentGuestData.address && currentGuestData.address.address_two) ||
        "";
      formData[`${key}[address][city_name]`] =
        (currentGuestData.address && currentGuestData.address.city_address) ||
        "";
      formData[`${key}[address][city_address]`] =
        (currentGuestData.address && currentGuestData.address.city_address) ||
        "";
      formData[`${key}[address][state_address]`] =
        (currentGuestData.address && currentGuestData.address.state_address) ||
        "";
      formData[`${key}[address][postcode]`] =
        (currentGuestData.address && currentGuestData.address.postcode) || "";

      formData[`${key}[nationality]`] = currentGuestData.nationality;
      formData[`${key}[nationality_code]`] = currentGuestData.nationalityCode;

      if (currentGuestData.document) {
        formData[`${key}[passport_image]`] = b64toBlob(
          currentGuestData.document.uri,
          currentGuestData.document.type,
          currentGuestData.document.name
        );
      }

      formData[`${key}[passport][document_number]`] = currentGuestData.passport;
      formData[`${key}[passport][document_id]`] =
        (bookingData.passport && bookingData.passport.document_id) || "";
      formData[`${key}[passport][effective_date]`] =
        (bookingData.passport && bookingData.passport.effective_date) || "";
      formData[`${key}[passport][place_of_issue]`] =
        (bookingData.passport && bookingData.passport.place_of_issue) || "";
      formData[`${key}[passport][country_of_issue]`] =
        (bookingData.passport && bookingData.passport.country_of_issue) || "";
      formData[`${key}[passport][primary]`] =
        (bookingData.passport && bookingData.passport.primary) || "";
    } else {
      formData[`${key}[address][country_of_residence_code]`] =
        (bookingData.address &&
          bookingData.address.country_of_residence_code) ||
        "";
      formData[`${key}[address][country_of_residence]`] =
        (bookingData.address && bookingData.address.country_of_residence) || "";
      formData[`${key}[nationality]`] = bookingData.nationality;
      formData[`${key}[nationality_code]`] = bookingData.nationality_code;
    }
    if (guestService.enablePassportExpiration) {
      formData[`${key}[passport][expiration_date]`] =
        (currentGuestData.dateOfExpiry &&
          moment.utc(currentGuestData.dateOfExpiry).format("YYYY-MM-DD")) ||
        "";
    }
    if (guestService.enableTM6) {
      formData[`${key}[arrival_card]`] = currentGuestData.tmSix;
    }
    if (guestService.enableArrivalInformation) {
      formData[`${key}[flight_arrive_time]`] = flightArrivalDate;
    }
    if (guestService.enableArrivalTime) {
      formData[`${key}[arrival_time]`] = arrivalTime;
    }
    if (guestService.enableComments) {
      formData[`${key}[special_requests][]`] = formValues.specialRequest;
    }
    if (currentGuestData.birthday) {
      formData[`${key}[dob]`] = moment
        .utc(currentGuestData.birthday)
        .format("YYYY-MM-DD");
    }
    formData[
      `${key}[phone][phone_number]`
    ] = `${currentGuestData.phoneCode}${currentGuestData.phone}`;
    formData[`${key}[phone][phone_country_code]`] = currentGuestData.phoneCode;
    formData[`${key}[phone][phone_number_without_code]`] =
      currentGuestData.phone;

    if (currentGuestData.signature && guestService.enableSignature) {
      formData[`${key}[signature_image]`] = b64toBlob(
        currentGuestData.signature.uri,
        currentGuestData.signature.type,
        currentGuestData.signature.name
      );
    }

    get(currentGuestData, "preferences", []).forEach((preference, index) => {
      formData[`${key}[preferences][${index}][description]`] =
        preference.description;
      formData[`${key}[preferences][${index}][preference_type]`] =
        preference.preference_type;
      formData[`${key}[preferences][${index}][preference_value]`] =
        preference.preference_value;
      formData[`${key}[preferences][${index}][selected]`] =
        preference.selected.toString();
    });

    if (arrivalFlight) {
      formData[`${key}[flight_no]`] = arrivalFlight;
    }
    formData[`${key}[node_id]`] = guestService.guest_service_id;
    formData[`${key}[payment_transaction_id]`] =
      Booking.getPaymentTransactionID(bookingNumber);
    formData[`${key}[user_token]`] = Booking.getUserToken(propertyUid);
    if (formValues.bedType) {
      formData[`${key}[bed_kind][]`] = formValues.bedType;
    }

    const additionalKey = `booking[additional_guests_info]`;
    allGuests.splice(0, 1); // remove primary guest
    allGuests.forEach((guest, index) => {
      key = `${additionalKey}[${index}]`;
      if (guest.completed) {
        formData[`${key}[room_code]`] = bookingData.room_code;
        formData[`${key}[room_description]`] = bookingData.room_description;
        formData[`${key}[number_of_rooms]`] = bookingData.number_of_rooms || 0;
        formData[`${key}[total_guests]`] = bookingData.total_guests || 0;
        formData[`${key}[total_keys]`] = bookingData.total_keys || 0;
        formData[`${key}[privacy_option][promotions]`] =
          (bookingData.privacy_option &&
            bookingData.privacy_option.promotions) ||
          "";

        formData[`${key}[check_in]`] = checkIn;
        formData[`${key}[check_out]`] = checkOut;
        formData[`${key}[stripe_vs_id]`] = guest.clientSecret;
        formData[`${key}[save_verification_to_profile]`] =
          guest.saveVerificationToProfile;
        formData[`${key}[title]`] = guest.title;
        formData[`${key}[first_name]`] = guest.firstName;
        formData[`${key}[last_name]`] = guest.lastName;
        formData[`${key}[email]`] = guest.email;
        formData[`${key}[guest_id]`] = guest.guestId || guest.guest_id;
        formData[`${key}[profile_id]`] = guest.profileId || guest.profile_id;
        formData[`${key}[guest_status]`] =
          guest.guestStatus || guest.guest_status;
        formData[`${key}[data_completed]`] = guest.completed && "true";
        formData[`${key}[passport][document_number]`] = "";
        if (guestService.enablePassport) {
          formData[`${key}[address][country_of_residence_code]`] =
            guest.countryCode;
          formData[`${key}[address][country_of_residence]`] = guest.country;

          formData[`${key}[address][address_one]`] =
            (guest.address && guest.address.address_one) || "";
          formData[`${key}[address][address_two]`] =
            (guest.address && guest.address.address_two) || "";
          formData[`${key}[address][city_name]`] =
            (guest.address && guest.address.city_address) || "";
          formData[`${key}[address][city_address]`] =
            (guest.address && guest.address.city_address) || "";
          formData[`${key}[address][state_address]`] =
            (guest.address && guest.address.state_address) || "";
          formData[`${key}[address][postcode]`] = formData[
            `${key}[nationality]`
          ] = guest.nationality;
          formData[`${key}[nationality_code]`] = guest.nationalityCode;

          if (guest.document) {
            formData[`${key}[passport_image]`] = b64toBlob(
              guest.document.uri,
              guest.document.type,
              guest.document.name
            );
          }

          formData[`${key}[passport][document_number]`] = guest.passport;
        } else {
          formData[`${key}[address][country_of_residence_code]`] =
            (bookingData.address &&
              bookingData.address.country_of_residence_code) ||
            "";
          formData[`${key}[address][country_of_residence]`] =
            (bookingData.address && bookingData.address.country_of_residence) ||
            "";
          formData[`${key}[nationality]`] = bookingData.nationality;
          formData[`${key}[nationality_code]`] = bookingData.nationality_code;
        }
        if (guestService.enablePassportExpiration) {
          formData[`${key}[passport][expiration_date]`] =
            (guest.dateOfExpiry &&
              moment.utc(guest.dateOfExpiry).format("YYYY-MM-DD")) ||
            "";
        }
        if (guestService.enableTM6) {
          formData[`${key}[arrival_card]`] = guest.tmSix;
        }
        if (guestService.enableArrivalInformation) {
          formData[`${key}[flight_arrive_time]`] = flightArrivalDate;
        }
        if (guestService.enableArrivalTime) {
          formData[`${key}[arrival_time]`] = arrivalTime;
        }
        if (guestService.enableComments) {
          formData[`${key}[special_requests][]`] = formValues.specialRequest;
        }

        if (guest.birthday) {
          formData[`${key}[dob]`] = moment
            .utc(guest.birthday)
            .format("YYYY-MM-DD");
        }
        formData[
          `${key}[phone][phone_number]`
        ] = `${guest.phoneCode}${guest.phone}`;
        formData[`${key}[phone][phone_country_code]`] = guest.phoneCode;
        formData[`${key}[phone][phone_number_without_code]`] = guest.phone;

        if (guest.signature && guestService.enableSignature) {
          formData[`${key}[signature_image]`] = b64toBlob(
            guest.signature.uri,
            guest.signature.type,
            guest.signature.name
          );
        }

        get(guest, "preferences", []).forEach((preference, index) => {
          formData[`${key}[preferences][${index}][description]`] =
            preference.description;
          formData[`${key}[preferences][${index}][preference_type]`] =
            preference.preference_type;
          formData[`${key}[preferences][${index}][preference_value]`] =
            preference.preference_value;
          formData[`${key}[preferences][${index}][selected]`] =
            preference.selected.toString();
        });

        if (arrivalFlight) {
          formData[`${key}[flight_no]`] = arrivalFlight;
        }
        formData[`${key}[node_id]`] = guestService.guest_service_id;
        if (formValues.bedType) {
          formData[`${key}[bed_kind][]`] = formValues.bedType;
        }
      }
    });

    // set user request params
    const allGuestsTmp = [...guests.allGuests()];
    let index = allGuestsTmp.findIndex((item) => item.currentGuest);
    const guestRequested = allGuestsTmp[index !== -1 ? index : 0];
    formData["user[user_token]"] = Booking.getUserToken(propertyUid);
    formData["user[email]"] = guestRequested.email;
    formData["user[guest_id]"] =
      guestRequested.guestId || guestRequested.guest_id;
    formData["user[title]"] = guestRequested.title;
    formData["user[first_name]"] = guestRequested.firstName;
    formData["user[last_name]"] = guestRequested.lastName;
    formData["user[nationality_code]"] = guestRequested.nationalityCode;
    if (guestRequested.birthday) {
      formData["user[dob]"] = moment
        .utc(guestRequested.birthday)
        .format("YYYY-MM-DD");
    }
    formData[
      "user[phone][phone_number]"
    ] = `${guestRequested.phoneCode}${guestRequested.phone}`;
    formData["user[address][country_of_residence_code]"] =
      guestRequested.countryCode;
    let uploadData = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      if (
        key.indexOf("document_number") > 0 ||
        key.indexOf("signature_image") > 0 ||
        key.indexOf("passport_image") > 0 ||
        (value && !isEmpty(value.toString()))
      ) {
        uploadData.append(key.replace(/\[\d+\]/g, "[]"), value);
      }
    }
    return uploadData;
  };

  const b64toBlob = (imageData, memeType = "image/png", name = "image.png") => {
    let blob = null;
    if (imageData) {
      var startIndex = imageData.indexOf("base64,") + 7;
      var b64 = imageData.substr(startIndex);
      let byteCharacters = window.atob(b64);
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray], {
        type: memeType,
        name: name,
      });
    }
    return blob;
  };

  const postBooking = async () => {
    let newAccessToken = accessToken;
    if (isEmpty(newAccessToken)) newAccessToken = await setAccessTokenData();
    if (!booked) {
      const bookingData = await bookingUploadData();
      await BookingService.postBooking(
        newAccessToken,
        booking.booking_id,
        bookingData
      )
        .then((response) => {
          if (
            get(response.data, "status") === "fetching" ||
            get(response.data, "status") === "processing_pre_checking"
          ) {
            setTimeout(() => {
              getBookingStatus();
            }, 3000); // set timer to call the booking api
          } else if (
            get(response.data, "status") === "ok" ||
            get(response.data, "status") === "finish"
          ) {
            updateErrorPage(true);
            setKeepLoading(false);
            Booking.setResultBooking(bookingNumber, response.data);
            history.push(
              `/pre-checkin/${propertyUid}/booking/${bookingNumber}/request-completed?language=${language}`
            );
          } else {
            updateErrorPage(true);
          }
        })
        .catch((error) => {
          if (get(error.response, "status") === 401) {
            setAccessTokenData();
          }
          console.error(error);
          updateErrorPage(true);
        });
    }
  };

  const getBookingStatus = async () => {
    const tmpGuests = [...guests.allGuests()];
    let index = tmpGuests.findIndex((item) => item.currentGuest);
    const currGuest = tmpGuests[index !== -1 ? index : 0];
    const email = encodeURI(currGuest.email);
    setRetries(retries + 1);
    if (retries + 1 > 20) {
      updateErrorPage(true);
    } else {
      await BookingService.getBookingStatus(
        accessToken,
        booking.booking_id,
        email
      )
        .then((response) => {
          if (
            get(response.data, "status") === "fetching" ||
            get(response.data, "status") === "processing_pre_checking"
          ) {
            setTimeout(() => {
              getBookingStatus();
            }, 3000); // set timer to call the booking api
          } else if (
            ["ok", "finish"].includes(get(response.data, "status")) &&
            response.data.data &&
            response.data.data.length !== 0
          ) {
            setBooked(true);
            Booking.setResultBooking(bookingNumber, response.data);
            setKeepLoading(false);
            history.push(
              `/pre-checkin/${propertyUid}/booking/${bookingNumber}/request-completed?language=${language}`
            );
          } else {
            updateErrorPage(true);
          }
        })
        .catch((error) => {
          if (get(error.response, "status") === 401) {
            setAccessTokenData();
          }
          console.error(error);
          updateErrorPage(true);
        });
    }
  };

  const mockingUp = async () => {
    await timeout(3000);
    setBooked(true);
    setKeepLoading(false);
    history.push(
      `/pre-checkin/${propertyUid}/booking/${bookingNumber}/request-completed?language=${language}`
    );
  };

  const timeout = (delay) => {
    return new Promise((res) => setTimeout(res, delay));
  };

  const getUpdateLicensePlateStatus = async (jobId, guestId) => {
    setRetries(retries + 1);
    if (retries + 1 > 10) {
      updateErrorModal(true, t("SOMETHING_WRONG"));
    } else {
      await ReservationService.getUpdateLicensePlateStatus(
        accessToken,
        jobId,
        guestId
      )
        .then((response) => {
          if (
            get(response.data, "status") === "fetching" ||
            get(response.data, "status") === "processing"
          ) {
            setTimeout(() => {
              getUpdateLicensePlateStatus(jobId, guestId);
            }, 3000); // set timer to call the booking api
          } else if (get(response.data, "status") === "failed") {
            setPageLoading(false);
            setConfirmationModal(false);
            updateErrorModal(
              true,
              get(response.data, "error") || t("SOMETHING_WRONG")
            );
          } else {
            setPageLoading(false);
            setConfirmationModal(false);
          }
        })
        .catch((error) => {
          if (get(error.response, "status") === 401) {
            setAccessTokenData();
          }
          console.error(error);
          setPageLoading(false);
          setConfirmationModal(false);
          updateErrorModal(
            true,
            get(error.response.data, "message") || t("SOMETHING_WRONG")
          );
        });
    }
  };

  const requestUpdateLicensePlate = async ({
    guestRequested,
    reservationId,
    licensePlate,
    guestId,
  }) => {
    window.scrollTo(0, 0);

    const user = {
      email: guestRequested.email,
      first_name: guestRequested.firstName,
      last_name: guestRequested.lastName,
    };

    await ReservationService.updateLicensePlate(
      accessToken,
      propertyUid,
      reservationId,
      licensePlate,
      guestId,
      language,
      user
    )
      .then((response) => {
        setPageLoading(true);
        setTimeout(() => {
          getUpdateLicensePlateStatus(get(response.data, "job_id"), guestId);
        }, 3000); // set ti
      })
      .catch((error) => {
        if (get(error.response, "status") === 401) {
          setAccessTokenData();
        }
        console.error(error);
        setPageLoading(false);
        setConfirmationModal(false);
        updateErrorModal(
          true,
          get(error.response.data, "message") || t("SOMETHING_WRONG")
        );
      });
  };

  const onUpdateUser = async () => {
    const allGuests = [...guests.allGuests()];
    let index = allGuests.findIndex((item) => item.currentGuest);
    const currGuest = allGuests[index !== -1 ? index : 0];
    currGuest.licensePlate = formValues.licensePlateNumber;
    guests.UpdateByNumber(index, currGuest);
    updateGuests(guests);
    if (!presets.demoMode) {
      await requestUpdateLicensePlate({
        guestRequested: currGuest,
        reservationId: booking.resv_id,
        licensePlate: formValues.licensePlateNumber,
        guestId: currGuest.guestId || currGuest.guest_id,
      });
    } else {
      setLoading(false);
      setConfirmationModal(false);
    }
  };

  const openConfirmModal = () => {
    setConfirmationModal(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const goToConfirmation = async () => {
    setSubmitted(true);
    let validate = true;
    if (
      guestService.enableSpecialRequest &&
      guestService.requiredSpecialRequest
    )
      validate = validate && !isEmpty(formValues.bedType);

    if (guestService.enableComments && guestService.requiredComments)
      validate = validate && !isEmpty(formValues.specialRequest);

    if (
      guestService.enableArrivalInformation &&
      guestService.requiredArrivalInformation
    )
      validate = validate && !isEmpty(formValues.arrivalFlight);

    if (guestService.enableArrivalTime && guestService.requiredArrivalTime)
      validate = validate && !isEmpty(formValues.arrivalTime);

    setValidateForm(validate);
    if (validate) {
      if (bookingNumber) {
        setLoading(true);
        if (presets.demoMode) {
          mockingUp();
        } else {
          postBooking();
        }
      } else {
        history.push(`/pre-checkin/${propertyUid}/home?language=${language}`);
      }
    }
  };

  useEffect(() => {
    if (isEmpty(currentGuest) && guests && booking) {
      const tmpGuests = [...guests.allGuests()];
      const currGuest = tmpGuests[0];
      setCurrentGuest(currGuest);
    }
    if (
      guestService &&
      booking &&
      !guestService.enableLicensePlateCollection &&
      !guestService.enableSpecialRequest &&
      !guestService.enableArrivalInformation &&
      !guestService.enableArrivalTime &&
      !guestService.enableComments
    ) {
      setKeepLoading(true);
      setLoading(true);
      goToConfirmation();
    }
  }, [
    currentGuest,
    guests,
    booking,
    guestService,
    setLoading,
    setKeepLoading,
    goToConfirmation,
  ]);

  const oneDayBeforeCheckIn = moment(booking?.checkInFormatDate).subtract(
    1,
    "day"
  );
  return (
    <>
      <PreCheckInContainer
        containerName="additional-information"
        headerLink>
        <PreCheckInHeader
          title={t("ADDITIONAL_INFORMATION", "ADDITIONAL INFORMATION")}
          headerLink
        />
        {booking && guestService && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <p
                className="type-regular medium mb-8 mt-6"
                style={{ whiteSpace: "pre-wrap" }}>
                {guestService.additionalInformationDescription}
              </p>

              {guestService.enableLicensePlateCollection && (
                <div className="flex flex-col text-center items-start justify-center">
                  <div className="max-w-xs m-auto">
                    <label
                      htmlFor="licensePlateNumber"
                      style={{ color: presets.backgroundColorTopBar }}
                      className="capitalize font-bold type-title medium mb-6">
                      {t("LICENSE_PLATE_NUMBER")}
                    </label>
                    <input
                      id="licensePlateNumber"
                      name="licensePlateNumber"
                      className="font-semibold uppercase rounded-lg text-gray-700 w-full type-normal large leading-tight text-4xl items-center justify-center self-center px-8 py-2 mb-2 border w-70 text-center outline-none focus:outline-none"
                      onChange={handleFormChange}
                      value={formValues.licensePlateNumber}
                      style={{
                        borderColor: presets.backgroundColorTopBar,
                      }}
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty("font-weight", "700", "important");
                        }
                      }}
                      placeholder="23FL89"
                    />
                    <button
                      className={`mb-28 uppercase type-title medium max-w-md text-center mx-auto w-full block py-4 ${presets.buttonStyleName}`}
                      disabled={formValues.licensePlateNumber.length === 0}
                      style={{
                        backgroundColor:
                          formValues.licensePlateNumber.length === 0
                            ? "#B5B6B7"
                            : presets.backgroundColorTopBar,
                        color: presets.appHomeTextCallToAction,
                      }}
                      onClick={() => openConfirmModal()}>
                      {t("UPDATE_USER")}
                    </button>
                    {confirmationModal && (
                      <ConfirmationFulfillmentModal
                        confirmOrderTitle={`${t("CONFIRM")}?`}
                        content={
                          <>
                            <p
                              className="font-semibold text-4xl large font-title type-normal"
                              ref={(el) => {
                                if (el) {
                                  el.style.setProperty(
                                    "font-weight",
                                    "600",
                                    "important"
                                  );
                                }
                              }}>
                              {t("LICENSE_PLATE_NUMBER_TEXT_1")}
                            </p>
                            <p
                              className="font-bold text-4xl large font-title type-normal items-center my-5"
                              ref={(el) => {
                                if (el) {
                                  el.style.setProperty(
                                    "font-weight",
                                    "700",
                                    "important"
                                  );
                                }
                              }}>
                              {formValues.licensePlateNumber?.toUpperCase()}
                            </p>
                            <p
                              className="font-semibold text-4xl large font-title type-normal"
                              ref={(el) => {
                                if (el) {
                                  el.style.setProperty(
                                    "font-weight",
                                    "600",
                                    "important"
                                  );
                                }
                              }}>
                              {t("LICENSE_PLATE_NUMBER_TEXT_2")}
                            </p>
                          </>
                        }
                        showConfirmation
                        openCloseModal={(showSecondConfirmation) => {
                          setConfirmationModal(showSecondConfirmation);
                          setPageLoading(false);
                        }}
                        onConfirm={() => onUpdateUser()}
                        loading={pageLoading}
                        okDisabled={pageLoading}
                        disabled={pageLoading}></ConfirmationFulfillmentModal>
                    )}
                  </div>
                </div>
              )}

              {guestService.enableSpecialRequest && (
                <div className="flex flex-col mb-24">
                  <p
                    style={{ color: presets.backgroundColorTopBar }}
                    className="type-regular medium mb-6">
                    {t("BED_TYPE", "BED TYPE").toUpperCase()}
                    {guestService.requiredSpecialRequest && (
                      <span className="text-gray-400 type-regular small pl-2">
                        {`*${t("REQUIRED")}`}
                      </span>
                    )}
                  </p>
                  <ul className="itemListTextStoreSubTitle">
                    <BetTypeLi className="mb-5 relative">
                      <RadioDiv>
                        <label
                          className="text-16 flex items-center text-okkami-cod-gray"
                          htmlFor="kind_bed">
                          <input
                            type="radio"
                            className="text-16"
                            id="kind_bed"
                            value="KNG"
                            name="bedType"
                            checked={formValues.bedType === "KNG"}
                            onChange={handleFormChange}
                          />
                          <span className="type-regular medium pl-1">
                            {t("KING_QUEEN_BED", "King / Queen Bed")}
                          </span>
                        </label>
                      </RadioDiv>
                    </BetTypeLi>
                    <BetTypeLi className="mb-5">
                      <RadioDiv>
                        <label
                          className="text-16 flex items-center text-okkami-cod-gray"
                          htmlFor="twin_bed">
                          <input
                            type="radio"
                            className="text-16"
                            id="twin_bed"
                            value="TWN"
                            name="bedType"
                            checked={formValues.bedType === "TWN"}
                            onChange={handleFormChange}
                          />
                          <span className="type-regular medium pl-1">
                            {t("TWIN_BEDS", "Twin Beds")}
                          </span>
                        </label>
                      </RadioDiv>
                    </BetTypeLi>
                  </ul>
                  {guestService.requiredSpecialRequest &&
                    !validateForm &&
                    submitted &&
                    isEmpty(formValues.bedType) && (
                      <p className="text-14 text-red-500 mt-5">
                        {t(
                          "PLEASE_FILL_OUT_REQUIRED",
                          "Please fill all the required fields"
                        )}
                      </p>
                    )}
                </div>
              )}

              {guestService.enableArrivalInformation && (
                <div className="mb-24">
                  <FloatInput
                    id="arrivalFlight"
                    name="arrivalFlight"
                    label={t("ARRIVAL_FLIGHT", "ARRIVAL FLIGHT").toUpperCase()}
                    span={
                      guestService.requiredArrivalInformation
                        ? `*${t("REQUIRED")}`
                        : ""
                    }
                    classNameLabel="mb-6 type-title small"
                    classNameSpan="text-gray-400 type-regular small pl-2"
                    classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
                    onChange={handleFormChange}
                    value={formValues.arrivalFlight ?? ""}
                    labelColor={presets.backgroundColorTopBar}
                    borderColor={presets.backgroundColorTopBar}
                  />
                  {guestService.requiredArrivalInformation &&
                    !validateForm &&
                    submitted &&
                    isEmpty(formValues.arrivalFlight) && (
                      <p className="text-14 text-red-500 mt-5">
                        {t(
                          "PLEASE_FILL_OUT_REQUIRED",
                          "Please fill all the required fields"
                        )}
                      </p>
                    )}
                </div>
              )}

              {guestService.enableArrivalInformation && (
                <div className="flex flex-col mb-24">
                  <p
                    style={{ color: presets.backgroundColorTopBar }}
                    className="type-title small mb-6">
                    {t(
                      "FLIGHT_ARRIVAL_TIME",
                      "FLIGHT ARRIVAL TIME"
                    ).toUpperCase()}
                    {guestService.requiredArrivalInformation && (
                      <span className="text-gray-400 type-regular small pl-2">
                        {`*${t("REQUIRED")}`}
                      </span>
                    )}
                  </p>
                  <DateTimePickerComponent
                    enableTime
                    modalTitle={t("FLIGHT_ARRIVAL_TIME", "FLIGHT ARRIVAL TIME")}
                    getDate={formValues.flightArrivalDate}
                    getTime={formValues.flightArrivalTime}
                    dateName="flightArrivalDate"
                    timeName="flightArrivalTime"
                    from={oneDayBeforeCheckIn}
                    to={booking.checkOutFormatDate}
                    step={guestService.flightArrivalTimeInterval}
                    primaryColor={presets.backgroundColorTopBar}
                    borderColor={presets.backgroundColorTopBar}
                    appHomeTextCallToAction={presets.appHomeTextCallToAction}
                    buttonStyleName={presets.buttonStyleName}
                    handleChange={handleFormChange}
                    format="DD MMM YYYY"
                    ampm={presets.standard_time_hour_format === "12-hour"}
                  />
                  {guestService.requiredArrivalInformation &&
                    !validateForm &&
                    submitted &&
                    isEmpty(formValues.flightArrivalDate) && (
                      <p className="text-14 text-red-500 mt-5">
                        {t(
                          "PLEASE_FILL_OUT_REQUIRED",
                          "Please fill all the required fields"
                        )}
                      </p>
                    )}
                </div>
              )}

              {guestService.enableArrivalTime && (
                <div className="flex flex-col mb-24">
                  <p
                    style={{ color: presets.backgroundColorTopBar }}
                    className="type-title small mb-6">
                    {t("ARRIVAL_TIME", "ARRIVAL TIME").toUpperCase()}
                    {guestService.requiredArrivalTime && (
                      <span className="text-gray-400 type-regular small pl-2">
                        {`*${t("REQUIRED")}`}
                      </span>
                    )}
                  </p>
                  <DateTimePickerComponent
                    enableTime
                    present
                    modalTitle={t("ARRIVAL_TIME", "ARRIVAL TIME")}
                    getDate={
                      formValues.arrivalDate ?? booking.checkInFormatDate
                    }
                    getTime={formValues.arrivalTime}
                    dateName="arrivalDate"
                    timeName="arrivalTime"
                    from={booking.checkInFormatDate}
                    to={booking.checkOutFormatDate}
                    step={guestService.arrivalTimeInterval}
                    primaryColor={presets.backgroundColorTopBar}
                    borderColor={presets.backgroundColorTopBar}
                    appHomeTextCallToAction={presets.appHomeTextCallToAction}
                    buttonStyleName={presets.buttonStyleName}
                    handleChange={handleFormChange}
                    format="DD MMM YYYY"
                    ampm={presets.standard_time_hour_format === "12-hour"}
                  />
                  {guestService.requiedArrivalTime &&
                    !validateForm &&
                    submitted &&
                    isEmpty(formValues.arrivalDate) && (
                      <p className="text-14 text-red-500 mt-5">
                        {t(
                          "PLEASE_FILL_OUT_REQUIRED",
                          "Please fill all the required fields"
                        )}
                      </p>
                    )}
                </div>
              )}

              {guestService.enableComments && (
                <div className="flex flex-col mb-24">
                  <p
                    style={{ color: presets.backgroundColorTopBar }}
                    className="type-title small mb-6">
                    {t("SPECIAL").toUpperCase()}
                    {guestService.requiredComments && (
                      <span className="text-gray-400 type-regular small pl-2">
                        {`*${t("REQUIRED")}`}
                      </span>
                    )}
                  </p>
                  <textarea
                    name="specialRequest"
                    value={formValues.specialRequest}
                    onChange={handleFormChange}
                    placeholder={t("ADD_SPECIAL_REQUEST")}
                    className="border rounded-lg py-8 w-full px-4 h-40 outline-none focus:outline-none type-normal large md:mb-10"
                    style={{ borderColor: presets.backgroundColorTopBar }}
                  />
                  {guestService.requiredComments &&
                    !validateForm &&
                    submitted &&
                    isEmpty(formValues.specialRequest) && (
                      <p className="text-14 text-red-500 mt-5">
                        {t(
                          "PLEASE_FILL_OUT_REQUIRED",
                          "Please fill all the required fields"
                        )}
                      </p>
                    )}
                </div>
              )}
              <button
                className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                style={{
                  backgroundColor: presets.backgroundColorTopBar,
                  color: presets.appHomeTextCallToAction,
                }}
                onClick={() => goToConfirmation()}>
                {t("CONTINUE")}
              </button>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => goToConfirmation()}>
              {t("CONTINUE")}
            </button>
          </>
        )}
      </PreCheckInContainer>
    </>
  );
};
export default withTranslation()(AdditionalInformation);
